// ============================================================
// A ONE-SHOT PIECE'S TIMING (plan body-map H2, H3): every hit moment,
// burst mark and special is drawn once and played by CSS from its own
// delay - this is the style that carries it.
// ============================================================

import type { CSSProperties } from 'react';

/**
 * A piece's start and length in seconds (CSS `animation-delay`, `-duration`; `dur` 0 keeps its class's own), with the
 * custom properties its keyframes read (`--dx`, `--from`, ...).
 */
export const timed = (at: number, dur = 0, vars: Record<string, number | string> = {}): CSSProperties =>
  ({ animationDelay: `${at.toFixed(3)}s`, ...(dur ? { animationDuration: `${dur}s` } : {}), ...vars }) as CSSProperties;
